import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=c894b2a4&scoped=true&"
import script from "./todoList.vue?vue&type=script&lang=js&"
export * from "./todoList.vue?vue&type=script&lang=js&"
import style0 from "./todoList.vue?vue&type=style&index=0&id=c894b2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c894b2a4",
  null
  
)

export default component.exports